import { createSlice } from "@reduxjs/toolkit";

export const RenderAppSlice = createSlice({
    name: "renderApp",
    initialState: {
        renderApp: 0,
    },
    reducers: {
        setRenderApp: (state, action) => {
            state.renderApp = action.payload;
        },
        resetRenderApp: (state, action) => {
            state.renderApp = 0;
        }
    }
});

export const { setRenderApp, resetRenderApp } = RenderAppSlice.actions;

export default RenderAppSlice.reducer;

